import React, { useState } from 'react';
import crypto from 'crypto-js';

function VerificationStatus({ proof }) {
  const [showPath, setShowPath] = useState(false);

  if (!proof || !proof.blockchainProof) return null;

  const isValid = proof.validationCode === 'VALID';
  const blockProof = proof.blockchainProof;

  const sha256 = (data) => crypto.SHA256(data).toString();

  // Recompute root from proof path to confirm validity
  let computedRoot = proof.blockHash;
  blockProof.proofPath.forEach((step) => {
    computedRoot = step.position === 'left'
      ? sha256(step.hash + computedRoot)
      : sha256(computedRoot + step.hash);
  });
  const rootMatches = computedRoot === blockProof.root;

  return (
    <div style={{
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      overflow: 'hidden',
      marginBottom: '10px',
      background: 'white'
    }}>
      {/* Summary bar */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 14px',
        background: isValid ? '#f0fff4' : '#fff5f5',
        borderBottom: showPath ? '1px solid #e0e0e0' : 'none'
      }}>
        <div style={{ display: 'flex', gap: '20px', alignItems: 'center', fontSize: '0.85rem' }}>
          <span style={{
            fontWeight: '700',
            color: isValid ? '#276749' : '#c53030',
            fontSize: '0.9rem'
          }}>
            {isValid ? 'Verified' : 'Invalid'} — Block #{proof.blockNumber}
          </span>
          <span style={{ color: '#555' }}>
            {blockProof.proofSteps} proof step{blockProof.proofSteps !== 1 ? 's' : ''} (O(log n))
          </span>
          <span style={{ color: '#555' }}>
            Root: {rootMatches
              ? <span style={{ color: '#276749' }}>matches</span>
              : <span style={{ color: '#c53030' }}>mismatch</span>}
          </span>
        </div>
        <button
          onClick={() => setShowPath(!showPath)}
          style={{
            padding: '3px 10px', fontSize: '0.78rem',
            background: 'transparent', border: '1px solid #ccc',
            borderRadius: '4px', cursor: 'pointer', color: '#555'
          }}
        >
          {showPath ? 'Hide Path' : 'Show Proof Path'}
        </button>
      </div>

      {/* Collapsible proof path */}
      {showPath && (
        <div style={{ padding: '12px 14px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.78rem' }}>
            <thead>
              <tr style={{ background: '#f5f5f5' }}>
                <th style={{ padding: '6px 8px', textAlign: 'left', fontWeight: '600', color: '#444' }}>Step</th>
                <th style={{ padding: '6px 8px', textAlign: 'left', fontWeight: '600', color: '#444' }}>Position</th>
                <th style={{ padding: '6px 8px', textAlign: 'left', fontWeight: '600', color: '#444' }}>Sibling Hash</th>
                <th style={{ padding: '6px 8px', textAlign: 'left', fontWeight: '600', color: '#444' }}>Block Range</th>
              </tr>
            </thead>
            <tbody>
              {blockProof.proofPath.map((step, idx) => (
                <tr key={idx} style={{ borderTop: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '6px 8px', color: '#333' }}>{idx + 1}</td>
                  <td style={{ padding: '6px 8px', color: '#333', textTransform: 'uppercase', fontSize: '0.75rem' }}>{step.position}</td>
                  <td style={{ padding: '6px 8px', fontFamily: 'monospace', color: '#555' }}>
                    {step.hash.substring(0, 12)}...{step.hash.substring(step.hash.length - 8)}
                  </td>
                  <td style={{ padding: '6px 8px', color: '#555' }}>
                    {step.minBlock !== undefined
                      ? step.minBlock === step.maxBlock ? `#${step.minBlock}` : `#${step.minBlock}–${step.maxBlock}`
                      : '—'}
                  </td>
                </tr>
              ))}
              <tr style={{ borderTop: '1px solid #e0e0e0', background: '#f9f9f9' }}>
                <td colSpan={2} style={{ padding: '6px 8px', fontWeight: '600', fontSize: '0.78rem', color: '#333' }}>Computed Root</td>
                <td colSpan={2} style={{ padding: '6px 8px', fontFamily: 'monospace', color: rootMatches ? '#276749' : '#c53030', fontSize: '0.78rem' }}>
                  {computedRoot.substring(0, 16)}...
                  {rootMatches ? '  (matches)' : '  (mismatch)'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default VerificationStatus;
